import React from "react";

const PreLoad = () => {
  return (
    <div className="preload preload-container">
      <div className="preload-logo">
        <div className="spinner" />
        <span className="icon icon-villa-fill" />
      </div>
    </div>
  );
};

export default PreLoad;
